/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Bar, Doughnut, Line, Pie } from 'react-chartjs-2';
import { DatePicker } from '@mui/lab';
import randomColor from 'randomcolor';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  Box,
  FormControlLabel,
  Checkbox,
  IconButton,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
} from '@mui/material';
import { spacing } from '@mui/system';
import axios from '../../CustomAxios';
import Loading from '../components/Loading';
import { CSVLink } from 'react-csv';
import { Download, FilterList } from '@mui/icons-material';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import { useNavigate } from 'react-router-dom';

const Card = styled(MuiCard)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function getFirstLastDateOfMonth(date) {
  const dt = new Date(date);
  const month = dt.getMonth();
  const year = dt.getFullYear();
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  return { firstDay, lastDay };
}

const getDataAnalytics = async (
  setJobData,
  jobConfig,
  setPlateData,
  plateConfig,
  setChallanData,
  challanConfig,
  setBillData,
  billConfig,
  setTopApUser,
  setTopApCompany,
  setLoader,
  auths,
  apCSV,
  setApCSV,
  setApUserStatData,
  setJobCategoryData,
  includeDeletedJobs,
  jobCategoryStartDate,
  jobCategoryEndDate,
  setJobCategoryStartDate,
  setJobCategoryEndDate
) => {
  if (jobCategoryStartDate > jobCategoryEndDate) {
    setJobCategoryEndDate(jobCategoryStartDate);
  }
  try {
    setLoader(true);
    const authData = JSON.parse(localStorage.getItem('AuthData'));
    const config = {
      headers: {
        Authorization: 'Bearer ' + authData.access_token,
      },
    };
    if (authData?.type === 'super_admin') {
      const jobCategoryRes = await axios.get(
        `/api/v1/${authData?.type}/jobs/category/stats?include_deleted=${includeDeletedJobs}&start_date=${jobCategoryStartDate.toISOString()}&end_date=${jobCategoryEndDate.toISOString()}`,
        config
      );
      if (jobCategoryRes.data.success) {
        setJobCategoryData(jobCategoryRes.data.data);
      }
    }
    if (
      auths?.user?.role?.permissions.includes('view_job_stats') ||
      authData?.type === 'super_admin'
    ) {
      let jobUrl;
      if (jobConfig.jobType === 'custom_range') {
        jobUrl = `/api/v1/${authData?.type}/dashboard/analytics/jobs?start_date=${jobConfig.startDate.toISOString()}&end_date=${jobConfig.endDate.toISOString()}&chart_type=${jobConfig.jobType}`;
      } else {
        jobUrl = `/api/v1/${authData?.type}/dashboard/analytics/jobs?chart_type=${jobConfig.jobType}&chart_year=${new Date(jobConfig.jobYear).getFullYear()}&chart_month=${new Date(jobConfig.jobMonth).getMonth()}`;
      }

      const { data } = await axios.get(
        jobUrl,
        config
      );
      if (data.success) {
        var jobA = randomColor({
          count: 1,
          luminosity: 'light',
          hue: 'random',
          format: 'hsla',
        });
        var jobB = randomColor({
          count: 1,
          luminosity: 'light',
          hue: 'random',
        });
        const time = [];
        // eslint-disable-next-line
        Object.keys(data.data['requested_job']).map((t) => {
          time.push(t);
        });

        const req_job_data = [];
        const process_job_data = [];
        for (let i = 0; i < time.length; i++) {
          req_job_data.push(data.data['requested_job'][time[i]]);
        }
        for (let i = 0; i < time.length; i++) {
          process_job_data.push(data.data['processed_job'][time[i]]);
        }

        setJobData({
          labels: time.map((t) => t),
          datasets: [
            {
              label: 'Requested Job',
              data: req_job_data.map((data) => data),
              backgroundColor: jobA,
            },
            {
              label: 'Processed Job',
              data: process_job_data.map((data) => data),
              backgroundColor: jobB,
            },
          ],
        });
      }
    }

    if (
      auths?.user?.role?.permissions.includes('view_plate_stats') ||
      authData?.type === 'super_admin'
    ) {

      let plateUrl;
      if (plateConfig.plateType === 'custom_range') {
        plateUrl = `/api/v1/${authData?.type}/dashboard/analytics/plates?start_date=${plateConfig.startDate.toISOString()}&end_date=${plateConfig.endDate.toISOString()}&chart_type=${plateConfig.plateType}`;
      } else {
        plateUrl = `/api/v1/${authData?.type}/dashboard/analytics/plates?chart_type=${plateConfig.plateType}&chart_year=${new Date(plateConfig.plateYear).getFullYear()}&chart_month=${new Date(plateConfig.plateMonth).getMonth()}`;
      }

      const plateData = await axios.get(
        plateUrl,
        config
      );

      if (plateData.data.success) {
        var plateA = randomColor({
          count: 1,
          luminosity: 'light',
          hue: 'random',
          format: 'hsla',
        });
        var plateB = randomColor({
          count: 1,
          luminosity: 'light',
          hue: 'random',
        });
        var plateC = randomColor({
          count: 1,
          luminosity: 'light',
          hue: 'random',
        });
        const plateTime = [];
        // eslint-disable-next-line
        Object.keys(plateData.data.data).map((t) => {
          plateTime.push(t);
        });

        const total_baked = [];
        const total_printout = [];
        const total_processed = [];

        for (let i = 0; i < plateTime.length; i++) {
          total_baked.push(plateData.data.data[plateTime[i]]['total_baked']);
          total_printout.push(plateData.data.data[plateTime[i]]['total_printout']);
          total_processed.push(plateData.data.data[plateTime[i]]['total_processed']);
        }

        setPlateData({
          labels: plateTime.map((t) => t),
          datasets: [
            {
              label: 'Total Baked',
              data: total_baked.map((data) => data),
              backgroundColor: plateA,
            },
            {
              label: 'Total Printout',
              data: total_printout.map((data) => data),
              backgroundColor: plateB,
            },
            {
              label: 'Total Processed',
              data: total_processed.map((data) => data),
              backgroundColor: plateC,
            },
          ],
        });
      }
    }

    if (
      auths?.user?.role?.permissions.includes('view_challan_stats') ||
      authData?.type === 'super_admin'
    ) {

      let challanUrl;
      if (challanConfig.challanType === 'custom_range') {
        challanUrl = `/api/v1/${authData?.type}/dashboard/analytics/challans?start_date=${challanConfig.startDate.toISOString()}&end_date=${challanConfig.endDate.toISOString()}&chart_type=${challanConfig.challanType}`;
      } else {
        challanUrl = `/api/v1/${authData?.type}/dashboard/analytics/challans?chart_type=${challanConfig.challanType}&chart_year=${new Date(challanConfig.challanYear).getFullYear()}&chart_month=${new Date(challanConfig.challanMonth).getMonth()}`;
      }

      const challandata = await axios.get(
        challanUrl,
        config
      );
      if (challandata.data.success) {
        var challanA = randomColor({
          count: 1,
          luminosity: 'light',
          hue: 'random',
          format: 'hsla',
        });
        var challanB = randomColor({
          count: 1,
          luminosity: 'light',
          hue: 'random',
        });
        const time = [];
        // eslint-disable-next-line
        Object.keys(challandata.data.data['created_challan']).map((t) => {
          time.push(t);
        });

        const created_challan = [];
        const accepted_challan = [];
        for (let i = 0; i < time.length; i++) {
          created_challan.push(challandata.data.data['created_challan'][time[i]]);
        }
        for (let i = 0; i < time.length; i++) {
          accepted_challan.push(challandata.data.data['accepted_challan'][time[i]]);
        }

        setChallanData({
          labels: time.map((t) => t),
          datasets: [
            {
              label: 'Created Challan',
              data: created_challan.map((data) => data),
              backgroundColor: challanA,
            },
            {
              label: 'Accepted Challan',
              data: accepted_challan.map((data) => data),
              backgroundColor: challanB,
            },
          ],
        });
      }
    }

    if (
      auths?.user?.role?.permissions.includes('view_bill_stats') ||
      authData?.type === 'super_admin'
    ) {

      let billUrl;
      if (billConfig.billType === 'custom_range') {
        billUrl = `/api/v1/${authData?.type}/dashboard/analytics/bills?start_date=${billConfig.startDate.toISOString()}&end_date=${billConfig.endDate.toISOString()}&chart_type=${billConfig.billType}`;
      } else {
        billUrl = `/api/v1/${authData?.type}/dashboard/analytics/bills?chart_type=${billConfig.billType}&chart_year=${new Date(billConfig.billYear).getFullYear()}&chart_month=${new Date(billConfig.billMonth).getMonth()}`;
      }

      const billData = await axios.get(
        billUrl,
        config
      );
      if (billData.data.success) {
        var billA = randomColor({
          count: 1,
          luminosity: 'light',
          hue: 'random',
          format: 'hsla',
        });
        var billB = randomColor({
          count: 1,
          luminosity: 'light',
          hue: 'random',
        });
        const time = [];
        // eslint-disable-next-line
        Object.keys(billData.data.data['generated_bill']).map((t) => {
          time.push(t);
        });

        const generated_bill = [];
        const cleared_bill = [];
        for (let i = 0; i < time.length; i++) {
          generated_bill.push(billData.data.data['generated_bill'][time[i]]);
        }
        for (let i = 0; i < time.length; i++) {
          cleared_bill.push(billData.data.data['cleared_bill'][time[i]]);
        }

        setBillData({
          labels: time.map((t) => t),
          datasets: [
            {
              label: 'Generated Bill',
              data: generated_bill.map((data) => data),
              backgroundColor: billA,
            },
            {
              label: 'Cleared Bill',
              data: cleared_bill.map((data) => data),
              backgroundColor: billB,
            },
          ],
        });
      }
    }

    const topApCompanyData = await axios.get(
      `/api/v1/${authData?.type}/dashboard/analytics/top_ap_company`,
      config
    );

    if (topApCompanyData.data.success) {
      var companyColor = randomColor({
        count: 10,
        luminosity: 'light',
        hue: 'random',
      });
      const companies = [];
      const plates = [];
      // eslint-disable-next-line
      topApCompanyData.data.data.map((plate) => {
        plates.push(plate.plate_processed);
        companies.push(plate?.ap_company_details?.name);
      });

      setTopApCompany({
        labels: companies,
        datasets: [
          {
            label: 'Top AP Companies',
            data: plates,
            hoverOffset: 4,
            backgroundColor: companyColor,
          },
        ],
      });
    }

    setLoader(false);
  } catch (e) {
    console.log(e);
    setLoader(false);
  }
};

function EmptyCard({
  jobData,
  plateData,
  setJobConfig,
  setPlateConfig,
  challanData,
  setChallanConfig,
  billData,
  setBillConfig,
  topApCompany,
  jobConfig,
  plateConfig,
  billConfig,
  challanConfig,
  auths,
  apCSV,
  apUserStatData,
  apUserStatFetching,
  fetchApUserAnalytics,
  jobCategoryData,
  setJobCategoryData,
  includeDeletedJobs,
  setIncludeDeletedJobs,
  jobCategoryStartDate,
  jobCategoryEndDate,
  setJobCategoryStartDate,
  setJobCategoryEndDate
}) {
  const [chosenMonthForApUser, setChosenMonthForApUser] = useState(new Date());
  const [topApUserCriteria, setTopApUserCriteria] = useState('all');
  const [topApUserChartData, setTopApUserChartData] = useState({});
  const authData = JSON.parse(localStorage.getItem('AuthData'));
  const [userCategoryData, setUserCategoryData] = useState({});
  const [userCategoryLoading, setUserCategoryLoading] = useState(false);
  const [jobCategoryCSV, setJobCategoryCSV] = useState({
    filename: 'job_category_distribution.csv',
    headers: [],
    data: []
  });
  const [userCategoryCSV, setUserCategoryCSV] = useState({
    filename: 'job_distribution.csv',
    headers: [],
    data: []
  });
  const [startDate, setStartDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  });
  const [endDate, setEndDate] = useState(new Date());

  // Temporary states for custom ranges
  const [tempJobStart, setTempJobStart] = useState(jobConfig.startDate);
  const [tempJobEnd, setTempJobEnd] = useState(jobConfig.endDate);
  const [tempPlateStart, setTempPlateStart] = useState(plateConfig.startDate);
  const [tempPlateEnd, setTempPlateEnd] = useState(plateConfig.endDate);
  const [tempChallanStart, setTempChallanStart] = useState(challanConfig.startDate);
  const [tempChallanEnd, setTempChallanEnd] = useState(challanConfig.endDate);
  const [tempBillStart, setTempBillStart] = useState(billConfig.startDate);
  const [tempBillEnd, setTempBillEnd] = useState(billConfig.endDate);
  const [tempJobCategoryStart, setTempJobCategoryStart] = useState(jobCategoryStartDate);
  const [tempJobCategoryEnd, setTempJobCategoryEnd] = useState(jobCategoryEndDate);

  // Apply handlers
  const applyJobCustomRange = () => {
    setJobConfig(prev => ({
      ...prev,
      startDate: tempJobStart,
      endDate: tempJobEnd
    }));
  };

  const applyPlateCustomRange = () => {
    setPlateConfig(prev => ({
      ...prev,
      startDate: tempPlateStart,
      endDate: tempPlateEnd
    }));
  };

  const applyChallanCustomRange = () => {
    setChallanConfig(prev => ({
      ...prev,
      startDate: tempChallanStart,
      endDate: tempChallanEnd
    }));
  };

  const applyBillCustomRange = () => {
    setBillConfig(prev => ({
      ...prev,
      startDate: tempBillStart,
      endDate: tempBillEnd
    }));
  };

  const applyJobCategoryRange = () => {
    setJobCategoryStartDate(tempJobCategoryStart);
    setJobCategoryEndDate(tempJobCategoryEnd);
  };

  const Challanoptions = {
    indexAxis: 'y',
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Challan Analytics',
      },
    },
  };

  const jobCategoryOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Job Category Distribution',
      },
    },
  };

  const jobOptions = {
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Job Analytics',
      },
    },
  };

  const plateOptions = {
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Plate Analytics',
      },
    },
  };

  const billOptions = {
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Bill Analytics',
      },
    },
  };

  const apUserOptions = {
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Top AP User Plate Analytics',
      },
    },
  };

  const apCompanyOptions = {
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Top AP Company Plate Analytics',
      },
    },
  };

  const userCategoryOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Your Jobs Distribution',
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || '';
            const value = context.formattedValue || '';
            return `${label}: ${value}`;
          }
        }
      }
    },
  };

  // Helper function to generate dynamic CSV for Top AP Users
  const generateApUserCSV = (criteria) => {
    let headers, csvData;

    if (criteria === 'all') {
      headers = [
        { label: 'User Name', key: 'name' },
        { label: 'New Count', key: 'new_count' },
        { label: 'New Cost', key: 'new_cost' },
        { label: 'Studio Count', key: 'studio_count' },
        { label: 'Studio Cost', key: 'studio_cost' },
        { label: 'CTP Impose Count', key: 'ctp_impose_count' },
        { label: 'CTP Impose Cost', key: 'ctp_impose_cost' },
        { label: 'CTP Count', key: 'ctp_count' },
        { label: 'CTP Cost', key: 'ctp_cost' },
        { label: 'Delivery Count', key: 'delivery_count' },
        { label: 'Delivery Cost', key: 'delivery_cost' },
        { label: 'Total Count', key: 'all_count' },
        { label: 'Total Cost', key: 'all_cost' },
      ];

      csvData = apUserStatData.map(user => {
        const all_count = user.new_count + user.studio_count + user.ctp_impose_count + user.ctp_count + user.delivery_count;
        const all_cost = user.new_cost + user.studio_cost + user.ctp_impose_cost + user.ctp_cost + user.delivery_cost;

        return {
          name: user.user_info?.name,
          new_count: user.new_count,
          new_cost: user.new_cost,
          studio_count: user.studio_count,
          studio_cost: user.studio_cost,
          ctp_impose_count: user.ctp_impose_count,
          ctp_impose_cost: user.ctp_impose_cost,
          ctp_count: user.ctp_count,
          ctp_cost: user.ctp_cost,
          delivery_count: user.delivery_count,
          delivery_cost: user.delivery_cost,
          all_count,
          all_cost
        };
      });
    } else {
      headers = [
        { label: 'User Name', key: 'name' },
        { label: `${criteria.charAt(0).toUpperCase() + criteria.slice(1)} Count`, key: `${criteria}_count` },
        { label: `${criteria.charAt(0).toUpperCase() + criteria.slice(1)} Cost`, key: `${criteria}_cost` },
      ];

      csvData = apUserStatData.map(user => ({
        name: user.user_info?.name,
        [`${criteria}_count`]: user[`${criteria}_count`],
        [`${criteria}_cost`]: user[`${criteria}_cost`],
      }));
    }

    const month = chosenMonthForApUser.getMonth();
    const year = chosenMonthForApUser.getFullYear();

    return {
      filename: `Top_AP_Users_${monthNames[month]}_${year}_${criteria}.csv`,
      headers: headers,
      data: csvData,
    };
  };

  useEffect(() => {
    const fetchUserCategoryStats = async () => {
      if (authData?.type === 'ap_user') {
        try {
          setUserCategoryLoading(true);
          const config = {
            headers: {
              Authorization: 'Bearer ' + authData.access_token,
            },
          };

          const response = await axios.get(
            `/api/v1/${authData?.type}/dashboard/analytics/user_category_stats/${authData?.user_id}?start_date=${startDate.toISOString()}&end_date=${endDate.toISOString()}`,
            config,
          );

          if (response.data.success) {
            // Generate CSV data
            const csvData = response.data.data.map(item => ({
              Category: item.category,
              'Total Jobs': item.total_jobs
            }));

            setUserCategoryCSV({
              filename: `job_distribution_${startDate.toISOString().split('T')[0]}_to_${endDate.toISOString().split('T')[0]}.csv`,
              headers: [
                { label: 'Category', key: 'Category' },
                { label: 'Total Jobs', key: 'Total Jobs' }
              ],
              data: csvData
            });

            // Existing chart data setup
            const chartData = {
              labels: response.data.data.map(item => item.category),
              datasets: [{
                data: response.data.data.map(item => item.total_jobs),
                backgroundColor: randomColor({
                  count: response.data.data.length,
                  luminosity: 'light',
                  hue: 'random'
                }),
                hoverOffset: 4
              }]
            };
            setUserCategoryData(chartData);
          }
        } catch (error) {
          console.error('Error fetching user category stats:', error);
        } finally {
          setUserCategoryLoading(false);
        }
      }
    };

    if (authData?.type === 'ap_user') {
      fetchUserCategoryStats();
    }
  }, [startDate, endDate]);

  function setUpTopApUserChart(topCriteria = 'all') {
    var apColor = randomColor({
      count: 10,
      luminosity: 'light',
      hue: 'random',
    });

    const chartLabels = [];
    const chartData = [];

    let sortedData;
    if (topCriteria === 'all') {
      // Aggregate counts for all categories
      sortedData = apUserStatData.map(user => ({
        ...user,
        all_count: user.new_count + user.studio_count + user.ctp_impose_count + user.ctp_count + user.delivery_count,
        all_cost: user.new_cost + user.studio_cost + user.ctp_impose_cost + user.ctp_cost + user.delivery_cost
      }));
      sortedData.sort((a, b) => b.all_count - a.all_count);
    } else {
      sortedData = sortTopUser(apUserStatData, topCriteria);
    }

    sortedData.forEach((el) => {
      if (topCriteria === 'all') {
        chartData.push(el.all_count);
      } else {
        chartData.push(el[`${topCriteria}_count`]);
      }
      chartLabels.push(el?.user_info?.name);
    });

    setTopApUserChartData({
      labels: chartLabels.slice(0, 10),
      datasets: [
        {
          label: 'Top AP Users',
          data: chartData.slice(0, 10),
          hoverOffset: 4,
          backgroundColor: apColor,
        },
      ],
    });
  }

  function sortTopUser(userData, criteria) {
    userData.sort(function (x, y) {
      if (x[`${criteria}_count`] < y[`${criteria}_count`]) {
        return 1;
      }
      if (x[`${criteria}_count`] > y[`${criteria}_count`]) {
        return -1;
      }
      return 0;
    });
    return userData;
  }

  function applyDateFilter() {
    const { firstDay, lastDay } = getFirstLastDateOfMonth(chosenMonthForApUser);
    fetchApUserAnalytics(firstDay.toISOString(), lastDay.toISOString());
  }

  useEffect(() => {
    setUpTopApUserChart(topApUserCriteria);

    const csvData = jobCategoryData.labels?.map((label, index) => ({
      Category: label,
      Jobs: jobCategoryData.datasets?.[0]?.data?.[index],
    })) || [];

    const headers = [
      { label: "Category", key: "Category" },
      { label: "Jobs", key: "Jobs" },
    ];

    setJobCategoryCSV({
      filename: `job_category_distribution_${monthNames[new Date(jobCategoryStartDate).getMonth()]}_${monthNames[new Date(jobCategoryEndDate).getMonth()]}.csv`,
      headers: headers,
      data: csvData,
    });
  }, [apUserStatData, jobCategoryData]);

  return (
    <>
      <Card mb={6}>
        <CardContent>
          <Paper style={{ padding: '2%' }}>
            <Grid container spacing={6}>
              {(auths?.user?.role?.permissions.includes('view_job_stats') ||
                authData?.type === 'super_admin') && (
                  <Grid item xs={12} md={12} lg={12}>
                    <Grid container spacing={6}>
                      <Grid
                        style={{ marginTop: 'auto', marginBottom: 'auto' }}
                        item
                        xs={12}
                        md={3}
                        lg={3}
                      >
                        <Grid container spacing={6}>
                          <Grid item xs={12} md={12} lg={12}>
                            <FormControl fullWidth>
                              <InputLabel id='label'>Select Job Chart type</InputLabel>
                              <Select
                                labelId='label'
                                fullWidth
                                id='label'
                                label='Select Job Chart type'
                                onChange={(e) => {
                                  setJobConfig((prev) => {
                                    return { ...prev, jobType: e.target.value };
                                  });
                                }}
                                value={jobConfig.jobType}
                              >
                                <MenuItem disabled value={''}>
                                  Select Chart Type
                                </MenuItem>

                                <MenuItem value={'by_month'}>By Month</MenuItem>
                                <MenuItem value={'by_week'}>By Week</MenuItem>
                                <MenuItem value="custom_range">Custom Range</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} md={12} lg={12}>
                            {jobConfig.jobType === 'by_month' ? (
                              <DatePicker
                                views={['year']}
                                label="Select Year"
                                value={jobConfig.jobYear}
                                onChange={(date) => setJobConfig(prev => ({
                                  ...prev,
                                  jobYear: date
                                }))}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                              />
                            ) : jobConfig.jobType === 'by_week' ? (
                              <DatePicker
                                views={['year', 'month']}
                                label="Select Month"
                                value={jobConfig.jobMonth}
                                onChange={(date) => setJobConfig(prev => ({
                                  ...prev,
                                  jobMonth: date
                                }))}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                              />
                            ) : (
                              <Grid container spacing={2}>
                                <Grid item xs={5}>
                                  <DatePicker
                                    label="Start Date"
                                    value={tempJobStart}
                                    onChange={setTempJobStart}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                  />
                                </Grid>
                                <Grid item xs={5}>
                                  <DatePicker
                                    label="End Date"
                                    value={tempJobEnd}
                                    onChange={setTempJobEnd}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                  />
                                </Grid>
                                <Grid item xs={2}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={applyJobCustomRange}
                                    fullWidth
                                    style={{ height: '100%' }}
                                  >
                                    Apply
                                  </Button>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={9} lg={9}>
                        <div>
                          {Object.keys(jobData).length !== 0 && (
                            <Bar options={jobOptions} data={jobData} />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

              {/* Plate Stats */}
              {(auths?.user?.role?.permissions.includes('view_plate_stats') ||
                authData?.type === 'super_admin') && (
                  <Grid item xs={12} md={12} lg={12}>
                    <Grid container spacing={6}>
                      <Grid
                        style={{ marginTop: 'auto', marginBottom: 'auto' }}
                        item
                        xs={12}
                        md={3}
                        lg={3}
                      >
                        <Grid container spacing={6}>
                          <Grid item xs={12} md={12} lg={12}>
                            <FormControl fullWidth>
                              <InputLabel id='label'>Select Plate Chart type</InputLabel>
                              <Select
                                labelId='label'
                                fullWidth
                                id='label'
                                label='Select Plate Chart type'
                                onChange={(e) => {
                                  setPlateConfig((prev) => {
                                    return { ...prev, plateType: e.target.value };
                                  });
                                }}
                                value={plateConfig.plateType}
                              >
                                <MenuItem disabled value={''}>
                                  Select Chart Type
                                </MenuItem>

                                <MenuItem value={'by_month'}>By Month</MenuItem>
                                <MenuItem value={'by_week'}>By Week</MenuItem>
                                <MenuItem value="custom_range">Custom Range</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            {plateConfig.plateType === 'by_month' ? (
                              <DatePicker
                                views={['year']}
                                label="Select Year"
                                value={plateConfig.plateYear}
                                onChange={(date) => setPlateConfig(prev => ({
                                  ...prev,
                                  plateYear: date
                                }))}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                              />
                            ) : plateConfig.plateType === 'by_week' ? (
                              <DatePicker
                                views={['year', 'month']}
                                label="Select Month"
                                value={plateConfig.plateMonth}
                                onChange={(date) => setPlateConfig(prev => ({
                                  ...prev,
                                  plateMonth: date
                                }))}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                              />
                            ) : (
                              <Grid container spacing={2}>
                                <Grid item xs={5}>
                                  <DatePicker
                                    label="Start Date"
                                    value={tempPlateStart}
                                    onChange={setTempPlateStart}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                  />
                                </Grid>
                                <Grid item xs={5}>
                                  <DatePicker
                                    label="End Date"
                                    value={tempPlateEnd}
                                    onChange={setTempPlateEnd}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                  />
                                </Grid>
                                <Grid item xs={2}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={applyPlateCustomRange}
                                    fullWidth
                                    style={{ height: '100%' }}
                                  >
                                    Apply
                                  </Button>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={9} lg={9}>
                        <div>
                          {Object.keys(plateData).length !== 0 && (
                            <Line options={plateOptions} data={plateData} />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

              {/* Challan Stats */}
              {auths?.user?.role?.permissions.includes(
                'view_challan_stats' || authData?.type === 'super_admin'
              ) && (
                  <Grid item xs={12} md={12} lg={12}>
                    <Grid container spacing={6}>
                      <Grid
                        style={{ marginTop: 'auto', marginBottom: 'auto' }}
                        item
                        xs={12}
                        md={3}
                        lg={3}
                      >
                        <Grid container spacing={6}>
                          <Grid item xs={12} md={12} lg={12}>
                            <FormControl fullWidth>
                              <InputLabel id='label'>Select Challan Chart type</InputLabel>
                              <Select
                                labelId='label'
                                fullWidth
                                id='label'
                                label='Select Challan Chart type'
                                onChange={(e) => {
                                  setChallanConfig((prev) => {
                                    return {
                                      ...prev,
                                      challanType: e.target.value,
                                    };
                                  });
                                }}
                                value={challanConfig.challanType}
                              >
                                <MenuItem disabled value={''}>
                                  Select Chart Type
                                </MenuItem>

                                <MenuItem value={'by_month'}>By Month</MenuItem>
                                <MenuItem value={'by_week'}>By Week</MenuItem>
                                <MenuItem value="custom_range">Custom Range</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            {challanConfig.challanType === 'by_month' ? (
                              <DatePicker
                                views={['year']}
                                label="Select Year"
                                value={challanConfig.challanYear}
                                onChange={(date) => setChallanConfig(prev => ({
                                  ...prev,
                                  challanYear: date
                                }))}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                              />
                            ) : challanConfig.challanType === 'by_week' ? (
                              <DatePicker
                                views={['year', 'month']}
                                label="Select Month"
                                value={challanConfig.challanMonth}
                                onChange={(date) => setChallanConfig(prev => ({
                                  ...prev,
                                  challanMonth: date
                                }))}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                              />
                            ) : (
                              <Grid container spacing={2}>
                                <Grid item xs={5}>
                                  <DatePicker
                                    label="Start Date"
                                    value={tempChallanStart}
                                    onChange={setTempChallanStart}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                  />
                                </Grid>
                                <Grid item xs={5}>
                                  <DatePicker
                                    label="End Date"
                                    value={tempChallanEnd}
                                    onChange={setTempChallanEnd}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                  />
                                </Grid>
                                <Grid item xs={2}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={applyChallanCustomRange}
                                    fullWidth
                                    style={{ height: '100%' }}
                                  >
                                    Apply
                                  </Button>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} md={9} lg={9}>
                        <div>
                          {Object.keys(challanData).length !== 0 && (
                            <Bar options={Challanoptions} data={challanData} />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

              {/* Bill Chart */}
              {(auths?.user?.role?.permissions.includes('view_bill_stats') ||
                authData?.type === 'super_admin') && (
                  <Grid item xs={12} md={12} lg={12}>
                    <Grid container spacing={6}>
                      <Grid
                        style={{ marginTop: 'auto', marginBottom: 'auto' }}
                        item
                        xs={12}
                        md={3}
                        lg={3}
                      >
                        <Grid container spacing={6}>
                          <Grid item xs={12} md={12} lg={12}>
                            <FormControl fullWidth>
                              <InputLabel id='label'>Select Bill Chart type</InputLabel>
                              <Select
                                labelId='label'
                                fullWidth
                                id='label'
                                label='Select Bill Chart type'
                                onChange={(e) => {
                                  setBillConfig((prev) => {
                                    return { ...prev, billType: e.target.value };
                                  });
                                }}
                                value={billConfig.billType}
                              >
                                <MenuItem disabled value={''}>
                                  Select Chart Type
                                </MenuItem>

                                <MenuItem value={'by_month'}>By Month</MenuItem>
                                <MenuItem value={'by_week'}>By Week</MenuItem>
                                <MenuItem value="custom_range">Custom Range</MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            {billConfig.billType === 'by_month' ? (
                              <DatePicker
                                views={['year']}
                                label="Select Year"
                                value={billConfig.billYear}
                                onChange={(date) => setBillConfig(prev => ({
                                  ...prev,
                                  billYear: date
                                }))}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                              />
                            ) : billConfig.billType === 'by_week' ? (
                              <DatePicker
                                views={['year', 'month']}
                                label="Select Month"
                                value={billConfig.billMonth}
                                onChange={(date) => setBillConfig(prev => ({
                                  ...prev,
                                  billMonth: date
                                }))}
                                renderInput={(params) => <TextField {...params} fullWidth />}
                              />
                            ) : (
                              <Grid container spacing={2}>
                                <Grid item xs={5}>
                                  <DatePicker
                                    label="Start Date"
                                    value={tempBillStart}
                                    onChange={setTempBillStart}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                  />
                                </Grid>
                                <Grid item xs={5}>
                                  <DatePicker
                                    label="End Date"
                                    value={tempBillEnd}
                                    onChange={setTempBillEnd}
                                    renderInput={(params) => <TextField {...params} fullWidth />}
                                  />
                                </Grid>
                                <Grid item xs={2}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={applyBillCustomRange}
                                    fullWidth
                                    style={{ height: '100%' }}
                                  >
                                    Apply
                                  </Button>
                                </Grid>
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={9} lg={9}>
                        <div>
                          {Object.keys(billData).length !== 0 && (
                            <Bar options={billOptions} data={billData} />
                          )}
                        </div>
                      </Grid>
                    </Grid>
                  </Grid>
                )}

              {authData?.type === 'super_admin' ? (
                <Grid item xs={12} md={12} lg={12} sx={{ mt: 4 }}>
                  <Grid container spacing={6}>
                    <Grid item xs={12} md={4} lg={4}>
                      {apUserStatFetching ? (
                        <Loading />
                      ) : (
                        <>
                          <Grid item xs={12}>
                            <Box>
                              {Array.isArray(topApUserChartData?.labels) &&
                                Array.isArray(topApUserChartData?.datasets) &&
                                topApUserChartData?.datasets?.length > 0 &&
                                apUserStatData.length > 0 ? (
                                <Doughnut options={apUserOptions} data={topApUserChartData} />
                              ) : (
                                <>
                                  <Box
                                    sx={{
                                      textAlign: 'center',
                                    }}
                                  >
                                    <Doughnut
                                      options={{
                                        ...apUserOptions,
                                        plugins: {
                                          ...apUserOptions.plugins,
                                          legend: {
                                            display: false,
                                          },
                                          tooltip: {
                                            enabled: false,
                                          },
                                        }
                                      }}
                                      data={{
                                        labels: ['No Data'],
                                        datasets: [
                                          {
                                            data: [30],
                                            backgroundColor: ['#f5f5f5'],
                                            borderWidth: 0,
                                          },
                                        ],
                                      }}
                                      sx={{
                                        my: 2
                                      }}
                                    />
                                    <Typography variant='h6' gutterBottom my={2}>
                                      No data available for given time period
                                    </Typography>
                                  </Box>
                                </>
                              )}
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Grid container spacing={2} sx={{ mt: 4 }}>
                              <Grid container spacing={4}>
                                <Grid item xs={12} md={6} lg={6}>
                                  <CSVLink
                                    style={{ color: 'green', textDecoration: 'none' }}
                                    {...generateApUserCSV(topApUserCriteria)}
                                  >
                                    <Button fullWidth variant='outlined' endIcon={<Download />}>
                                      Top AP User CSV
                                    </Button>
                                  </CSVLink>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                  <FormControl fullWidth size='small'>
                                    <InputLabel id='label'>Select Category</InputLabel>
                                    <Select
                                      labelId='label'
                                      fullWidth
                                      id='label'
                                      label='Select Category'
                                      onChange={(e) => {
                                        setTopApUserCriteria(e.target.value);
                                        setUpTopApUserChart(e.target.value);
                                      }}
                                      value={topApUserCriteria}
                                      size='small'
                                    >
                                      <MenuItem disabled value={''}>
                                        Select Chart Type
                                      </MenuItem>
                                      <MenuItem value={'all'}>All</MenuItem>
                                      <MenuItem value={'new'}>By Docket (New)</MenuItem>
                                      <MenuItem value={'studio'}>By Studio</MenuItem>
                                      <MenuItem value={'ctp_impose'}>By CTP Impose</MenuItem>
                                      <MenuItem value={'ctp'}>By CTP</MenuItem>
                                      <MenuItem value={'delivery'}>By Delivery</MenuItem>
                                    </Select>
                                  </FormControl>
                                </Grid>
                              </Grid>
                              <Grid container spacing={4} sx={{ mt: 2 }}>
                                <Grid item xs={12} md={6} lg={6}>
                                  <FormControl fullWidth size='small'>
                                    <DatePicker
                                      views={['year', 'month']}
                                      label='Select Bills Year And Month'
                                      value={chosenMonthForApUser}
                                      onChange={(month) => {
                                        setChosenMonthForApUser(new Date(month));
                                      }}
                                      renderInput={(params) => (
                                        <TextField size='small' {...params} helperText={null} />
                                      )}
                                    />
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12} md={6} lg={6}>
                                  <Button
                                    variant='outlined'
                                    startIcon={<CachedOutlinedIcon />}
                                    fullWidth
                                    onClick={applyDateFilter}
                                  >
                                    Apply Filter
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </>
                      )}
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <div>
                        <Pie options={apCompanyOptions} data={topApCompany} />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={4} lg={4}>
                      <div>
                        {Object.keys(jobCategoryData).length !== 0 ? (
                          <Pie options={jobCategoryOptions} data={jobCategoryData} />
                        ) : (
                          <Box sx={{ textAlign: 'center', p: 3 }}>
                            <Typography variant="body1">No job category data available</Typography>
                          </Box>
                        )}
                      </div>
                      <Grid container width={'100%'} justifyContent={'space-around'} alignItems={'center'}
                      >
                        <CSVLink
                          {...jobCategoryCSV}
                          style={{ textDecoration: 'none' }}
                        >
                          <Button
                            variant="outlined"
                            startIcon={<Download />}
                            color="primary"
                          >
                            Download CSV
                          </Button>
                        </CSVLink>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={includeDeletedJobs}
                              onChange={(e) => setIncludeDeletedJobs(e.target.checked)}
                              color="primary"
                            />
                          }
                          label={
                            <span style={{ fontSize: '0.9rem' }}>
                              Include deleted jobs
                            </span>
                          }
                          sx={{ my: 4, justifyContent: 'center', alignItems: 'center' }}
                        />
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={5}>
                          <DatePicker
                            label="Start Date"
                            value={tempJobCategoryStart}
                            onChange={setTempJobCategoryStart}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                          />
                        </Grid>
                        <Grid item xs={5}>
                          <DatePicker
                            label="End Date"
                            value={tempJobCategoryEnd}
                            onChange={setTempJobCategoryEnd}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                          />
                        </Grid>
                        <Grid item xs={2}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={applyJobCategoryRange}
                            fullWidth
                            style={{ height: '100%' }}
                          >
                            Apply
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              ) : null}

              {authData?.type === 'ap_user' && (
                <Grid item xs={12} md={12} lg={12} sx={{ mt: 5 }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      {userCategoryLoading ? (
                        <Loading />
                      ) : (
                        userCategoryData.labels?.length > 0 ? (
                          <>
                            <Doughnut
                              data={userCategoryData}
                              options={userCategoryOptions}
                            />
                            <Box mt={2} textAlign="center">
                              <CSVLink
                                {...userCategoryCSV}
                                style={{ textDecoration: 'none' }}
                              >
                                <Button
                                  variant="outlined"
                                  startIcon={<Download />}
                                  color="primary"
                                >
                                  Download CSV
                                </Button>
                              </CSVLink>
                            </Box>
                          </>
                        ) : null
                      )}
                      <Grid item xs={12} md={12} mt={4}>
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <DatePicker
                              label="Start Date"
                              value={startDate}
                              onChange={(date) => setStartDate(date)}
                              renderInput={(params) => <TextField {...params} fullWidth />}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <DatePicker
                              label="End Date"
                              value={endDate}
                              onChange={(date) => setEndDate(date)}
                              renderInput={(params) => <TextField {...params} fullWidth />}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Date pickers for start/end dates */}
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Paper>
        </CardContent>
      </Card>
    </>
  );
}

function ApDashboard({ auths }) {
  const navigate = useNavigate();
  const [jobConfig, setJobConfig] = useState({
    jobType: 'by_month',
    jobYear: new Date(),
    jobMonth: new Date(),
    startDate: new Date(),
    endDate: new Date()
  });

  const [plateConfig, setPlateConfig] = useState({
    plateType: 'by_month',
    plateYear: new Date(),
    plateMonth: new Date(),
    startDate: new Date(),
    endDate: new Date()
  });

  const [challanConfig, setChallanConfig] = useState({
    challanType: 'by_month',
    challanYear: new Date(),
    challanMonth: new Date(),
    startDate: new Date(),
    endDate: new Date()
  });

  const [billConfig, setBillConfig] = useState({
    billType: 'by_month',
    billYear: new Date(),
    billMonth: new Date(),
    startDate: new Date(),
    endDate: new Date()
  });

  const [jobData, setJobData] = useState({});
  const [plateData, setPlateData] = useState({});
  const [challanData, setChallanData] = useState({});
  const [billData, setBillData] = useState({});
  const [topApUser, setTopApUser] = useState({});
  const [apUserStatData, setApUserStatData] = useState([]);
  const [topApCompany, setTopApCompany] = useState({});
  const [loader, setLoader] = useState(true);
  const [apCSV, setApCSV] = useState({});
  const [apUserStatFetching, setApUserStatFetching] = useState(true);
  const [jobCategoryData, setJobCategoryData] = useState({});
  const [includeDeletedJobs, setIncludeDeletedJobs] = useState(false);
  const [jobCategoryStartDate, setJobCategoryStartDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  });;
  const [jobCategoryEndDate, setJobCategoryEndDate] = useState(new Date());

  // --- New state for active stats cards ---
  const [activeStats, setActiveStats] = useState({
    active_jobs: 0,
    active_challans: 0,
    active_bills: 0,
  });
  const [activeStatsLoading, setActiveStatsLoading] = useState(false);
  const [activeStatsStartDate, setActiveStatsStartDate] = useState(() => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  });
  const [activeStatsEndDate, setActiveStatsEndDate] = useState(new Date());
  const [selectedApCompany, setSelectedApCompany] = useState('');
  const [apCompaniesList, setApCompaniesList] = useState([]);
  const [filterModalOpen, setFilterModalOpen] = useState(false);

  // Temporary modal filter state
  const [tempModalStartDate, setTempModalStartDate] = useState(activeStatsStartDate);
  const [tempModalEndDate, setTempModalEndDate] = useState(activeStatsEndDate);
  const [tempModalApCompany, setTempModalApCompany] = useState(selectedApCompany);

  // --- Fetch active stats from backend ---
  const fetchActiveStats = async (start, end, apCompany) => {
    try {
      setActiveStatsLoading(true);
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: { Authorization: 'Bearer ' + authData.access_token },
      };
      let url = `/api/v1/${authData?.type}/dashboard/analytics/active_stats?start_date=${start.toISOString()}&end_date=${end.toISOString()}`;
      if (authData?.type === 'super_admin' && apCompany) {
        url += `&ap_company=${apCompany}`;
      }
      const response = await axios.get(url, config);
      if (response.data.success) {
        setActiveStats(response.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch active stats:', error);
    } finally {
      setActiveStatsLoading(false);
    }
  };

  // --- Fetch list of AP companies for super_admin dropdown ---
  const fetchApCompanies = async () => {
    if (auths?.user?.type !== 'super_admin') return;
    try {
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: { Authorization: 'Bearer ' + authData.access_token },
      };
      const response = await axios.get('/api/v1/super_admin/ap-companies', config);
      if (response.data.success) {
        setApCompaniesList(response.data.data);
      }
    } catch (error) {
      console.error('Failed to fetch AP companies:', error);
    }
  };

  const handleOpenFilterModal = () => {
    setTempModalStartDate(activeStatsStartDate);
    setTempModalEndDate(activeStatsEndDate);
    setTempModalApCompany(selectedApCompany);
    setFilterModalOpen(true);
  };

  const handleApplyFilters = () => {
    setActiveStatsStartDate(tempModalStartDate);
    setActiveStatsEndDate(tempModalEndDate);
    setSelectedApCompany(tempModalApCompany);
    setFilterModalOpen(false);
    fetchActiveStats(tempModalStartDate, tempModalEndDate, tempModalApCompany);
  };

  const handleCloseModal = () => {
    setFilterModalOpen(false);
  };

  useEffect(() => {
    fetchApCompanies();
  }, []);

  useEffect(() => {
    fetchActiveStats(activeStatsStartDate, activeStatsEndDate, selectedApCompany);
  }, [activeStatsStartDate, activeStatsEndDate, selectedApCompany]);

  useEffect(() => {
    getDataAnalytics(
      setJobData,
      jobConfig,
      setPlateData,
      plateConfig,
      setChallanData,
      challanConfig,
      setBillData,
      billConfig,
      setTopApUser,
      setTopApCompany,
      setLoader,
      auths,
      apCSV,
      setApCSV,
      setApUserStatData,
      setJobCategoryData,
      includeDeletedJobs,
      jobCategoryStartDate,
      jobCategoryEndDate,
      setJobCategoryStartDate,
      setJobCategoryEndDate
    );
  }, [jobConfig, plateConfig, challanConfig, billConfig, auths.user, includeDeletedJobs, jobCategoryStartDate, jobCategoryEndDate]);

  useEffect(() => {
    const { firstDay, lastDay } = getFirstLastDateOfMonth(new Date());
    fetchApUserAnalytics(firstDay.toISOString(), lastDay.toISOString());
  }, []);

  async function fetchApUserAnalytics(startDate, endDate) {
    try {
      setApUserStatFetching(true);
      const authData = JSON.parse(localStorage.getItem('AuthData'));
      const config = {
        headers: {
          Authorization: 'Bearer ' + authData.access_token,
        },
      };
      let apiUri = `/api/v1/${authData?.type}/dashboard/analytics/top_ap_user?`;
      if (_.isString(startDate)) {
        apiUri += `start_date=${startDate}&`;
      }
      if (_.isString(endDate)) {
        apiUri += `end_date=${endDate}`;
      }
      const topApData = await axios.get(apiUri, config);
      if (topApData.data.success) {
        setApUserStatData(topApData.data.data);
      }
      setApUserStatFetching(false);
    } catch (e) {
      console.log(e);
    }
  }

  // Helper to format date as YYYY-MM-DD for query params
  const formatDateParam = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
  };

  // Build URL with current filters for navigation
  const buildUrlWithFilters = (basePath, extraParams = {}) => {
    const params = new URLSearchParams(extraParams);
    if (activeStatsStartDate) {
      // For jobs, the param is received_date_from; for others it's created_date_from
      if (basePath.includes('jobs')) {
        params.append('received_from', formatDateParam(activeStatsStartDate));
        params.append('received_to', formatDateParam(activeStatsEndDate));
      } else if (basePath.includes('challan')) {
        params.append('challan_created_from', formatDateParam(activeStatsStartDate));
        params.append('challan_created_to', formatDateParam(activeStatsEndDate));
      } else {
        params.append('bill_created_from', formatDateParam(activeStatsStartDate));
        params.append('bill_created_to', formatDateParam(activeStatsEndDate));
      }
    }
    const authData = JSON.parse(localStorage.getItem('AuthData'));
    if (authData?.type === 'super_admin' && selectedApCompany) {
      params.append('ap_company', selectedApCompany);
    }
    return `${basePath}?${params.toString()}`;
  };

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title='Alpha Plus' />
        <Grid justifyContent='space-between' alignItems='center' container spacing={10} mb={4}>
          <Grid item>
            <Typography
              variant='h4'
              gutterBottom
              display='inline'
              sx={{ fontWeight: 600 }}
              color='primary'
            >
              STATS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label='Breadcrumb' mt={2}>
              <Link component={NavLink} to='/dashboard/tasks'>
                Dashboard
              </Link>
              <Typography> Stats</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          {/* Active Stats Cards Section */}
          <Grid item xs={12}>
            <Grid container spacing={3}>
              {/* Header with title, filter summary, and filter icon */}
              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                  <Box display="flex" alignItems="center" gap={2}>
                    <Typography variant="h6" color="textSecondary">
                      Active Stats
                    </Typography>
                    {/* Display active filters */}
                    {(activeStatsStartDate || activeStatsEndDate || selectedApCompany) && (
                      <Box display="flex" alignItems="center" gap={1}>
                        {activeStatsStartDate && (
                          <Chip
                            label={`From: ${formatDateParam(activeStatsStartDate)}`}
                            size="small"
                            variant="outlined"
                          />
                        )}
                        {activeStatsEndDate && (
                          <Chip
                            label={`To: ${formatDateParam(activeStatsEndDate)}`}
                            size="small"
                            variant="outlined"
                          />
                        )}
                        {selectedApCompany && (
                          <Chip
                            label={`AP: ${apCompaniesList.find(c => c._id === selectedApCompany)?.name || selectedApCompany}`}
                            size="small"
                            variant="outlined"
                            color="primary"
                          />
                        )}
                      </Box>
                    )}
                  </Box>
                  <IconButton onClick={handleOpenFilterModal} color="primary">
                    <FilterList />
                  </IconButton>
                </Box>
              </Grid>

              {/* Stat Cards */}
              {activeStatsLoading ? (
                <Grid item xs={12}>
                  <Loading />
                </Grid>
              ) : (
                <>
                  <Grid item xs={12} md={4}>
                    <Card
                      onClick={() => {
                        const url = buildUrlWithFilters('/dashboard/jobs', { current_status: 'delivery' });
                        navigate(url);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <CardContent>
                        <Typography color="textSecondary" gutterBottom variant="h6">
                          Active Jobs
                        </Typography>
                        <Typography variant="h3">{activeStats.active_jobs}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          Jobs not yet completed
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Card
                      onClick={() => {
                        const url = buildUrlWithFilters('/dashboard/challan', { bill_created: 'NO' });
                        navigate(url);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <CardContent>
                        <Typography color="textSecondary" gutterBottom variant="h6">
                          Active Challans
                        </Typography>
                        <Typography variant="h3">{activeStats.active_challans}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          Challans not yet converted to bills
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Card
                      onClick={() => {
                        const url = buildUrlWithFilters('/dashboard/bill', { payment_completed: 'NO' });
                        navigate(url);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      <CardContent>
                        <Typography color="textSecondary" gutterBottom variant="h6">
                          Active Bills
                        </Typography>
                        <Typography variant="h3">{activeStats.active_bills}</Typography>
                        <Typography variant="body2" color="textSecondary">
                          Bills not fully paid
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>

          {/* Filter Modal */}
          <Dialog open={filterModalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
            <DialogTitle>Filter Active Stats</DialogTitle>
            <DialogContent>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                {auths?.user?.type === 'super_admin' && (
                  <Grid item xs={12}>
                    <FormControl fullWidth size="small">
                      <InputLabel>AP Company</InputLabel>
                      <Select
                        value={tempModalApCompany}
                        onChange={(e) => setTempModalApCompany(e.target.value)}
                        label="AP Company"
                      >
                        <MenuItem value="">All Companies</MenuItem>
                        {apCompaniesList.map((company) => (
                          <MenuItem key={company._id} value={company._id}>
                            {company.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label="Start Date"
                    value={tempModalStartDate}
                    onChange={setTempModalStartDate}
                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label="End Date"
                    value={tempModalEndDate}
                    onChange={setTempModalEndDate}
                    renderInput={(params) => <TextField {...params} fullWidth size="small" />}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseModal}>Cancel</Button>
              <Button onClick={handleApplyFilters} variant="contained" color="primary">
                Apply
              </Button>
            </DialogActions>
          </Dialog>

          {/* Existing analytics charts */}
          <Grid item xs={12}>
            <EmptyCard
              jobConfig={jobConfig}
              setJobConfig={setJobConfig}
              jobData={jobData}
              plateConfig={plateConfig}
              plateData={plateData}
              setPlateConfig={setPlateConfig}
              challanData={challanData}
              challanConfig={challanConfig}
              setChallanConfig={setChallanConfig}
              billData={billData}
              billConfig={billConfig}
              setBillConfig={setBillConfig}
              topApUser={topApUser}
              topApCompany={topApCompany}
              auths={auths}
              loader={loader}
              apCSV={apCSV}
              apUserStatData={apUserStatData}
              apUserStatFetching={apUserStatFetching}
              fetchApUserAnalytics={fetchApUserAnalytics}
              jobCategoryData={jobCategoryData}
              setJobCategoryData={setJobCategoryData}
              includeDeletedJobs={includeDeletedJobs}
              setIncludeDeletedJobs={setIncludeDeletedJobs}
              jobCategoryStartDate={jobCategoryStartDate}
              jobCategoryEndDate={jobCategoryEndDate}
              setJobCategoryStartDate={setJobCategoryStartDate}
              setJobCategoryEndDate={setJobCategoryEndDate}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(ApDashboard);